// extracted by mini-css-extract-plugin
export var BtnV2 = "templates-module--BtnV2--1e4a3";
export var BtnV2Black = "templates-module--BtnV2--black--cb4b8";
export var BtnV2Borderless = "templates-module--BtnV2--borderless--34f71";
export var BtnV2Cloud = "templates-module--BtnV2--cloud--2e38d";
export var BtnV2Disabled = "templates-module--BtnV2--disabled--3f185";
export var BtnV2Focusable = "templates-module--BtnV2--focusable--2e0a0";
export var BtnV2Fullwidth = "templates-module--BtnV2--fullwidth--d99b1";
export var BtnV2Gold = "templates-module--BtnV2--gold--06f1e";
export var BtnV2Grey = "templates-module--BtnV2--grey--c5498";
export var BtnV2Icon = "templates-module--BtnV2--icon--1d48d";
export var BtnV2Lg = "templates-module--BtnV2--lg--f6573";
export var BtnV2Midnight = "templates-module--BtnV2--midnight--90b30";
export var BtnV2Multiline = "templates-module--BtnV2--multiline--eaeb3";
export var BtnV2Nofocus = "templates-module--BtnV2--nofocus--4463d";
export var BtnV2Secondary = "templates-module--BtnV2--secondary--53e0b";
export var BtnV2Sm = "templates-module--BtnV2--sm--99687";
export var BtnV2Solid = "templates-module--BtnV2--solid--7a3ad";
export var BtnV2Square = "templates-module--BtnV2--square--a3210";
export var BtnV2Success = "templates-module--BtnV2--success--dfd14";
export var BtnV2Text = "templates-module--BtnV2--text--4f127";
export var BtnV2Warning = "templates-module--BtnV2--warning--c872d";
export var BtnV2White = "templates-module--BtnV2--white--c66c7";
export var BtnV2Xl = "templates-module--BtnV2--xl--f8a5a";
export var BtnV2Yellow = "templates-module--BtnV2--yellow--05f03";
export var ColorBlock = "templates-module--ColorBlock--bc4c8";
export var ColorBlockColorGrey = "templates-module--ColorBlock--colorGrey--eb972";
export var ColorBlockGrey = "templates-module--ColorBlock--grey--3d416";
export var ColorBlockMidGrey = "templates-module--ColorBlock--midGrey--8bcbf";
export var ColorBlockPink = "templates-module--ColorBlock--pink--742d4";
export var ColorBlockPrimary = "templates-module--ColorBlock--primary--53313";
export var ColorBlockPrimaryDark = "templates-module--ColorBlock--primaryDark--2e547";
export var ColorBlockPrimaryLight = "templates-module--ColorBlock--primaryLight--7ce54";
export var ColorBlockPrimaryMid = "templates-module--ColorBlock--primaryMid--11b75";
export var ColorBlockPurple = "templates-module--ColorBlock--purple--06237";
export var ColorBlockRed = "templates-module--ColorBlock--red--8a9c9";
export var ColorBlockSecondary = "templates-module--ColorBlock--secondary--1ba16";
export var ColorBlockSecondaryDark = "templates-module--ColorBlock--secondaryDark--3b24e";
export var ColorBlockSecondaryLight = "templates-module--ColorBlock--secondaryLight--f2d12";
export var ColorBlockSecondaryMid = "templates-module--ColorBlock--secondaryMid--6da1e";
export var ColorBlockText = "templates-module--ColorBlock--text--9b060";
export var ColorBlockYellow = "templates-module--ColorBlock--yellow--4b0fd";
export var ColorBlocks = "templates-module--ColorBlocks--16b08";
export var DashboardTopoptions = "templates-module--Dashboard--topoptions--c5366";
export var HideEmbedded = "templates-module--HideEmbedded--cc7c0";
export var ShowEmbedded = "templates-module--ShowEmbedded--a4957";
export var Template__descriptionContent = "templates-module--Template__description-content--4dfd5";
export var __active = "templates-module--__active--c7bf5";
export var __custom = "templates-module--__custom--8465a";
export var _pin = "templates-module--_pin--9e47f";
export var _pinText = "templates-module--_pinText--9a74a";
export var aliceCarousel__dots = "templates-module--alice-carousel__dots--43dca";
export var aliceCarousel__dotsItem = "templates-module--alice-carousel__dots-item--44dbd";
export var btnGroup = "templates-module--btn-group--45a8b";
export var ccCompliance = "templates-module--cc-compliance--01e15";
export var featuredTemplate = "templates-module--featuredTemplate--346c9";
export var filters = "templates-module--filters--a499a";
export var filtersInner = "templates-module--filtersInner--ed2df";
export var filtersMobile = "templates-module--filtersMobile--3e9e0";
export var h1 = "templates-module--h1--f577c";
export var h2 = "templates-module--h2--75de9";
export var h3 = "templates-module--h3--5d0d6";
export var h4 = "templates-module--h4--9cf5e";
export var hero = "templates-module--hero--1dfd0";
export var heroContent = "templates-module--heroContent--c2365";
export var link = "templates-module--link--71fed";
export var maxWidth = "templates-module--max-width--3d951";
export var menuOpen = "templates-module--menu-open--6a5b6";
export var noChildPMb = "templates-module--no-child-p-mb--bbc67";
export var nobar = "templates-module--nobar--39f14";
export var pageWrapper = "templates-module--pageWrapper--111bc";
export var pin = "templates-module--pin--3b826";
export var search = "templates-module--search--b0c34";
export var seogroup = "templates-module--seogroup--0366c";
export var template = "templates-module--template--5eb54";
export var templateContent = "templates-module--templateContent--0a482";
export var templateDescription = "templates-module--templateDescription--9edc7";
export var templateFilter = "templates-module--templateFilter--c8638";
export var templateGrid = "templates-module--templateGrid--380d7";
export var templateGridFeatured = "templates-module--templateGridFeatured--f0b97";
export var templateGridFeaturedInner = "templates-module--templateGridFeaturedInner--5a130";
export var templateGroupFeaturedTitle = "templates-module--templateGroupFeaturedTitle--e657d";
export var templateGroupTitle = "templates-module--templateGroupTitle--37bba";
export var templateTitle = "templates-module--templateTitle--64b1a";
export var templateWrapper = "templates-module--templateWrapper--6d54e";
export var templateWrapperDark = "templates-module--templateWrapperDark--18abf";
export var templateWrapperSlider = "templates-module--templateWrapperSlider--909ab";
export var templates = "templates-module--templates--ac2bc";